import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import LogisticsRfqTypeSelection from './LogisticsRfqTypeSelection';

export default function LogisticsRfqTypeSelectionModal({
  open,
  onClose,
  companyId = null,
  title = 'Send logistics RFQ',
  introText,
  onNavigate,
}) {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    onClose?.();
    if (onNavigate) onNavigate(path);
    else navigate(path);
  };

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onClose}
      footer={null}
      width={720}
      centered
      destroyOnClose
      className="logistics-rfq-selection-modal"
    >
      <LogisticsRfqTypeSelection
        companyId={companyId}
        onNavigate={handleNavigate}
        introText={introText}
      />
    </Modal>
  );
}
